/** Voltage-drop display helpers (spec §3.5 islanded handling, review E5). */

import type { TransformerVoltageDrop } from '../types/engineering.ts'

/** Minimum estimated voltage over transformers reachable from the source,
 *  capped at 1.0 pu. Islanded rows carry estimated_voltage_pu=0.0 and
 *  unplaceable rows carry null; neither may pin the min (an unfiltered null
 *  coerces to 0 inside Math.min). Returns null when no comparable rows exist. */
export function minReachableVoltagePu(
  drops: TransformerVoltageDrop[],
): number | null {
  const values = drops
    .filter(td => td.source_reachable !== false && td.drop_status !== 'islanded')
    .map(td => td.estimated_voltage_pu)
    .filter((pu): pu is number => pu != null)
  if (values.length === 0) return null
  return Math.min(...values, 1)
}
